import { render, staticRenderFns } from "./ChinaBroadnetCancelModal.vue?vue&type=template&id=52c1d14f&"
import script from "./ChinaBroadnetCancelModal.vue?vue&type=script&lang=js&"
export * from "./ChinaBroadnetCancelModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports